import { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  addComment,
  getComments,
  getComment,
  editComment,
  deleteComment,
  getAllComments,
} from "../../store/actions/comment_action";
import _debounce from "lodash/debounce";
// import { useSelectAllIndustry } from "./UseIndustry";

// Get All Data
export const useAllComments = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.comment);
  const [reloadData, setReloadData] = useState(false);
  const [activity, setActivity] = useState(null);
  useEffect(async () => {
    if (activity) {
      await dispatch(getComments(activity));
    }
  }, [activity]);
  useEffect(async () => {
    if (reloadData) {
      await dispatch(getComments(activity));
      setReloadData(false);
    }
  }, [reloadData]);
  // console.log("ACTT")
  return [data, setActivity, setReloadData];
};

// Get Single Data
export const useSingleComment = (id) => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.comment);
  useEffect(() => {
    dispatch(getComment(id));
  }, [id]);
  return [data];
};
// Add Data
export const useCreateComment = () => {
  const dispatch = useDispatch();
  const data = useSelector((state) => state.comment);
  const addData = async (data) => {
    await dispatch(addComment(data));
  };
  return [data, addData];
};
export const useUpdateComment = () => {
  const dispatch = useDispatch();
  // const data = useSelector((state) => state.comment);
  const updateData = async (id, data) => {
    await dispatch(editComment(id, data));
  };
  return [updateData];
};

export const useSelectAllComment = () => {
  const dispatch = useDispatch();
  const [term, setTerm] = useState("");
  const [value, setValue] = useState("");
  const data = useSelector((state) => state.comment);
  useEffect(() => {
    dispatch(getAllComments({ term, value }));
  }, [term, value]);
  return [data, setTerm, setValue];
};

export const useGetDropdownOptions = () => {
  //  const [client, setClientSearchField, setClientSearchValue] =
  // useSelectAllClient();

  const [dropdownOptions, setDropdownOptions] = useState({});
  // useEffect(() => {
  //   if (industry && industry.all_industrys) {
  //     const newData = industry.all_industrys.map((item) => {
  //       return { label: item.name, value: item.name };
  //     });
  //     setDropdownOptions({ ...dropdownOptions, industry: newData });
  //   }
  // }, [industry]);

  return [
    dropdownOptions,
    // setClientSearchField, setClientSearchValue
  ];
};
